import { A } from '../actions/summary';
import update from 'immutability-helper';

const initialState = {
  summary: {
    report_sales_sum_1: {
      today: ``,
      week: ``,
    },
    report_orders_sum_1: {
      today: ``,
      week: ``,
    },
    report_sales_avg_order_1: {
      month: ``,
      allTime: ``,
    },
    report_orders_sale_percent_1: {
      month: ``,
      allTime: ``,
    },
    report_sales_dynamic_1: {
      week: ``,
      previousWeek: ``,
      previousMonth: ``,
    },
    report_sales_dynamic_1_delivered: {
      week: ``,
      previousWeek: ``,
      previousMonth: ``,
    },
    report_orders_dynamic_1: {
      week: ``,
      previousWeek: ``,
      previousMonth: ``,
    },
    report_orders_dynamic_1_with_canceled: {
      week: ``,
      previousWeek: ``,
      previousMonth: ``,
    },
    report_goods_turnover_1: {
      week: ``,
      previousWeek: ``,
      previousMonth: ``,
    },
    report_sales_channels_1: {
      channelSales: [],
    },
    report_sales_avg_order_full_1: {
      week: 0,
      month: 0,
      allTime: 0,
      annuallyData: [],
    },
    report_orders_sum_full_1: {
      week: 0,
      month: 0,
      allTime: 0,
      annuallyData: [],
    },
    report_top_selling_products_1: {
      products: [],
    },
    report_last_changed_orders_1: {
      orders: [],
    },
    report_goods_margin_1: {
      channelSales: [],
      date: '',
      warning: [],
    },
    report_goods_margin_1_delivered: {
      channelSales: [],
      date: '',
      warning: [],
    },
  },
};

const summary = (state = initialState, action) => {
  switch (action.type) {
    case A.FETCH_SUMMARY_SUCCESS:
      return update(state, {
        summary: { $set: action.summary },
      });

    case A.RECEIVE_RECALCULATE_PRODUCT_MARGIN_SHIPPED:
      state.summary.report_goods_margin_1 = action.data;
      const updated_with_margin_1 = JSON.parse(JSON.stringify(state.summary));
      return update(state, {
        summary: { $set: updated_with_margin_1 },
      });

    case A.RECEIVE_RECALCULATE_PRODUCT_MARGIN_DELIVERED:
      state.summary.report_goods_margin_1_delivered = action.data;
      const updated_with_margin_1_delivered = JSON.parse(JSON.stringify(state.summary));
      return update(state, {
        summary: { $set: updated_with_margin_1_delivered },
      });

    default:
      return state;
  }
};

export default summary;
